import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import "driver.js/dist/driver.css";
import React from "react";
import BlockFeedContentNew from "./BlockFeedContentNew";
import { closeOutline } from "ionicons/icons";

type BlockFeedProps = {
  isUserSettingsModalOpen: any;
  isBlockFeedOpen: boolean;
  setIsBlockFeedOpen: Function;
  currentSelectedProfile: number | undefined;
};

const BlockFeed: React.FC<BlockFeedProps> = ({
  isBlockFeedOpen,
  setIsBlockFeedOpen,
  currentSelectedProfile,
}) => {
  return (
    <IonModal isOpen={isBlockFeedOpen}>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonTitle>
            <p className="ion-no-margin text-bold">BLOCK TRADES</p>
          </IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => setIsBlockFeedOpen(false)}>
              <IonIcon
                icon={closeOutline}
                color="dark"
                slot="icon-only"
              ></IonIcon>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <BlockFeedContentNew currentSelectedProfile={currentSelectedProfile} />
    </IonModal>
  );
};

export default BlockFeed;
